/**
 * AbilityGateSection — race ability gate state (active, allowlist mode).
 */

import React from 'react';
import { Section, Row } from '../RaceDebugPrimitives';

const COLOR = '#9b59b6';

export const AbilityGateSection: React.FC<{
  gateActive: boolean;
  gateAllowedCount: number | null;
}> = ({ gateActive, gateAllowedCount }) => (
  <Section title="Ability Gate" color={COLOR}>
    <Row label="active" value={gateActive ? 'YES' : 'no'}
         valueColor={gateActive ? '#e74c3c' : '#666'} />
    {gateActive && (
      <Row label="mode"
           value={gateAllowedCount !== null
             ? `allowlist (${gateAllowedCount} ids)`
             : 'denylist-only'} />
    )}
  </Section>
);
